export default __webpack_public_path__ + "static/media/294.21430cf1.gif";